import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Loader from '~/components/Loader';
import Wrapper from '~/components/Wrapper';
import useAuthentication from '~/hooks/use-authentication';
import useTrackPageView from '~/hooks/use-track-page-view';

function Logout() {
  useTrackPageView('Log out');
  const { logout, isLoggedIn, isLoading } = useAuthentication();
  const history = useHistory();

  useEffect(() => {
    logout();
  }, [logout]);

  useEffect(() => {
    if (!isLoading && !isLoggedIn) history.replace('/login');
  }, [isLoggedIn, history, isLoading]);

  return (
    <Wrapper center>
      <Loader />
      <p>Logging you out</p>
    </Wrapper>
  );
}

export default Logout;
